import {
  clearModal,
  showModal,
  showNotification,
  clearNotification
} from '@shoflo/studio-redux/actions';
import { LOST_REALTIME_SOCKET_CONNECTION } from '../constants/ModalTypes';

/**
 * @param {Function} dispatch
 */
export function showWebSocketReconnectionMessage(dispatch) {
  dispatch(clearModal(LOST_REALTIME_SOCKET_CONNECTION));
  dispatch(
    showNotification('Realtime connection restored', {
      type: 'success',
      timeout: 1000 * 3
    })
  );
}

/**
 *
 * @param {Function} dispatch
 * @param {Object} initialValue
 */
export function showRealtimeErrorMessageModal(dispatch, initialValue = null) {
  dispatch(clearNotification());
  dispatch(showModal(LOST_REALTIME_SOCKET_CONNECTION, initialValue));
}

/**
 *
 * @param {*} dispatch
 * @param {*} socket
 */
export function checkRealtimeConnection(dispatch, socket) {
  if (!socket?._socket?.connected) {
    showRealtimeErrorMessageModal(dispatch);
  }
}
